var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextHotspotDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 181.817,
    height: 183.874,
    viewBox: "0 0 181.817 183.874",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258",
    transform: "translate(-877 -574.126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255",
    transform: "translate(115 95.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "text_fields_FILL0_wght400_GRAD0_opsz48",
    d: "M31.321,75.251A5.2,5.2,0,0,1,26.067,70V18.508H9.254A5.2,5.2,0,0,1,4,13.254,5.2,5.2,0,0,1,9.254,8H53.388a5.2,5.2,0,0,1,5.254,5.254,5.2,5.2,0,0,1-5.254,5.254H36.575V70a5.2,5.2,0,0,1-5.254,5.254Zm37.829,0A5.2,5.2,0,0,1,63.9,70V39.524H55.489a5.276,5.276,0,0,1-3.73-8.984,5.073,5.073,0,0,1,3.73-1.524H82.81A5.276,5.276,0,0,1,86.54,38a5.073,5.073,0,0,1-3.73,1.524H74.4V70a5.2,5.2,0,0,1-5.254,5.254Z",
    transform: "translate(797.876 539.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(762 499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    transform: "translate(0 -0.186)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 82,
    r: 82,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 82,
    r: 79,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 28,
    height: 31,
    transform: "translate(1013 591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cancel_24dp_E8EAED_FILL1_wght400_GRAD0_opsz24",
    d: "M102.506-854.343l6.527,6.527a2.135,2.135,0,0,0,1.575.619,2.135,2.135,0,0,0,1.575-.619,2.134,2.134,0,0,0,.619-1.575,2.134,2.134,0,0,0-.619-1.575l-6.527-6.527,6.527-6.527a2.133,2.133,0,0,0,.619-1.575,2.134,2.134,0,0,0-.619-1.576,2.134,2.134,0,0,0-1.575-.619,2.134,2.134,0,0,0-1.575.619l-6.527,6.527-6.527-6.527a2.134,2.134,0,0,0-1.575-.619,2.134,2.134,0,0,0-1.575.619,2.134,2.134,0,0,0-.619,1.576,2.133,2.133,0,0,0,.619,1.575l6.527,6.527-6.527,6.527a2.134,2.134,0,0,0-.619,1.575,2.135,2.135,0,0,0,.619,1.575,2.135,2.135,0,0,0,1.575.619,2.135,2.135,0,0,0,1.575-.619Zm0,19.355a21.914,21.914,0,0,1-8.777-1.772,22.728,22.728,0,0,1-7.146-4.811,22.73,22.73,0,0,1-4.811-7.146A21.917,21.917,0,0,1,80-857.494a21.917,21.917,0,0,1,1.772-8.777,22.728,22.728,0,0,1,4.811-7.146,22.728,22.728,0,0,1,7.146-4.811A21.918,21.918,0,0,1,102.506-880a21.918,21.918,0,0,1,8.777,1.772,22.727,22.727,0,0,1,7.146,4.811,22.728,22.728,0,0,1,4.811,7.146,21.917,21.917,0,0,1,1.772,8.777,21.917,21.917,0,0,1-1.772,8.778,22.731,22.731,0,0,1-4.811,7.146,22.727,22.727,0,0,1-7.146,4.811A21.914,21.914,0,0,1,102.506-834.988Z",
    transform: "translate(1560.846 1284.777) rotate(-45)",
    fill: "#6913b3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextHotspotDrop);
export default __webpack_public_path__ + "static/media/text_hotspot_drop.1da8407cbddb5335e60592ce2f33c705.svg";
export { ForwardRef as ReactComponent };